class MenuOpenContext {
  constructor(buildData) {
    this.isHeader = buildData.isHeader || false;
    this.isMultipleParaSelected = buildData.isMultipleParaSelected || false;
    this.isMaxParaSelected = buildData.isMaxParaSelected || false;
    this.isDescriptionSelected = buildData.isDescriptionSelected || false;

    this.isCompilation = buildData.isCompilation || false;
    this.isReader = buildData.isReader || false;
    this.isEditor = buildData.isEditor || false;
    this.isAdvancedSearch = buildData.isAdvancedSearch || false;

    this.isCreateDiscussionVisible =
      buildData.isCreateDiscussionVisible || false;
    this.isOffline = buildData.isOffline || false;
    this.hasAudio = buildData.hasAudio || false;
    this.isAdmin = buildData.isAdmin || false;
    this.isUserEditor = buildData.isUserEditor || false;
    this.isGuest = buildData.isGuest || false;
    this.isDesktop = buildData.isDesktop || false;
    this.isDevice = buildData.isDevice || false;
    this.hasIlmId = buildData.hasIlmId || false;
    this.brand = buildData.brand || null;
    this.isElementVoiced = buildData.isElementVoiced || false;
    this.isVisibleCopyInSafari = buildData.isVisibleCopyInSafari || false;
    this.isMaterialsEditMode = buildData.isMaterialsEditMode || false;

    this.showReportAboutErrors = buildData.showReportAboutErrors || false;
    this.readerIsEqualToStudent = buildData.readerIsEqualToStudent || false;
  }

  changeIsHeader(isHeader) {
    this.isHeader = isHeader;
    return this;
  }

  changeIsMultipleParaSelected(isMultipleParaSelected) {
    this.isMultipleParaSelected = isMultipleParaSelected;
    return this;
  }

  changeIsMaxParaSelected(isMaxParaSelected) {
    this.isMaxParaSelected = isMaxParaSelected;
    return this;
  }

  changeIsDescriptionSelected(isDescriptionSelected) {
    this.isDescriptionSelected = isDescriptionSelected;
    return this;
  }

  changeIsElementVoiced(isElementVoiced) {
    this.isElementVoiced = isElementVoiced;
    return this;
  }

  changeIsGuest(isGuest) {
    this.isGuest = isGuest;
    return this;
  }

  changeIsAdmin(isAdmin) {
    this.isAdmin = isAdmin;
    return this;
  }

  changeIsOffline(isOffline) {
    this.isOffline = isOffline;
    return this;
  }
}

class MenuOpenContextBuilder {
  setIsHeader(isHeader) {
    this.isHeader = isHeader;
    return this;
  }
  setIsMultipleParaSelected(isMultipleParaSelected) {
    this.isMultipleParaSelected = isMultipleParaSelected;
    return this;
  }
  setIsDescriptionSelected(isDescriptionSelected) {
    this.isDescriptionSelected = isDescriptionSelected;
    return this;
  }
  setIsCompilation(isCompilation) {
    this.isCompilation = isCompilation;
    return this;
  }
  setIsEditor(isEditor) {
    this.isEditor = isEditor;
    return this;
  }
  setIsReader(isReader) {
    this.isReader = isReader;
    return this;
  }
  setIsAdvancedSearch(isAdvancedSearch) {
    this.isAdvancedSearch = isAdvancedSearch;
    return this;
  }
  setIsCreateDiscussionVisible(isCreateDiscussionVisible) {
    this.isCreateDiscussionVisible = isCreateDiscussionVisible;
    return this;
  }
  setIsOffline(isOffline) {
    this.isOffline = isOffline;
    return this;
  }
  setHasAudio(hasAudio) {
    this.hasAudio = hasAudio;
    return this;
  }
  setIsAdmin(isAdmin) {
    this.isAdmin = isAdmin;
    return this;
  }
  setIsUserEditor(isUserEditor) {
    this.isUserEditor = isUserEditor;
    return this;
  }
  setIsGuest(isGuest) {
    this.isGuest = isGuest;
    return this;
  }
  setIsDesktop(isDesktop) {
    this.isDesktop = isDesktop;
    return this;
  }
  setIsDevice(isDevice) {
    this.isDevice = isDevice;
    return this;
  }
  setHasIlmId(hasIlmId) {
    this.hasIlmId = hasIlmId;
    return this;
  }
  setBrand(brand) {
    this.brand = brand;
    return this;
  }
  setIsElementVoiced(isElementVoiced) {
    this.isElementVoiced = isElementVoiced;
    return this;
  }

  setIsVisibleCopyInSafari(isVisibleCopyInSafari) {
    this.isVisibleCopyInSafari = isVisibleCopyInSafari;
    return this;
  }
  setIsMaterialsEditMode(isMaterialsEditMode) {
    this.isMaterialsEditMode = isMaterialsEditMode;
    return this;
  }
  setShowReportAboutErrors(showReportAboutErrors) {
    this.showReportAboutErrors = showReportAboutErrors;
    return this;
  }
  setReaderIsEqualToStudent(readerIsEqualToStudent) {
    this.readerIsEqualToStudent = readerIsEqualToStudent;
    return this;
  }

  build() {
    return new MenuOpenContext(this);
  }
}

function getMenuOpenContextBuilder(state, brand) {
  return new MenuOpenContextBuilder(state, brand);
}

export default {
  getMenuOpenContextBuilder
};
